import { Injectable, Injector } from "@angular/core";
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export class LanguageLoader implements TranslateLoader {
    private http: HttpClient;
    private injector: Injector;
    prefix: string;
    suffix: string;

    constructor(
        http: HttpClient,
        injector: Injector,
        prefix?: string,
        suffix?: string
    ) {
        this.http = http;
        this.injector = injector;
        this.prefix = prefix;
        this.suffix = suffix;
    }

    getTranslation(lang: string): Observable<any> {
        const translate = this.injector.get(TranslateService);
        return Observable.create((observer) => {
            // Instant load (does not work)
            // observer.next(this.getLocalTranslation(lang));

            translate.setTranslation(lang, this.getLocalTranslation(lang), false);

            this.http.get(`${this.prefix}${lang}${this.suffix}`).subscribe(data => {
                localStorage.setItem('i18n_' + lang, JSON.stringify(data));
                observer.next(data);
                // translate.setTranslation(lang, data, false);
            }, error => {
                // Backup load
                observer.next(this.getLocalTranslation(lang));
            });
        });
    }

    getLocalTranslation(lang: string): any {
        try {
            return JSON.parse(localStorage.getItem('i18n_' + lang));
        } catch (e) {
            console.error(e);
        }

        return [];
    }
}